(function () {
    'use strict';

    angular
        .module('app')
        .config(config);

    var aHrefSanitizationWhitelist = /^\s*((https?|ftp|mailto|tel|file):)|(javascript:void\(0\))/;

    config.$inject = ['$locationProvider', '$compileProvider', '$httpProvider', '$templateRequestProvider', '$logProvider', '$transitionsProvider', '$qProvider', 'tmhDynamicLocaleProvider', 'gettextCatalogProvider', 'urls', 'uibDatepickerConfig', 'uibDatepickerPopupConfig', 'defaultHttpRequestTransform', 'uiGmapGoogleMapApiProvider', 'localStorageServiceProvider'];
    function config($locationProvider, $compileProvider, $httpProvider, $templateRequestProvider, $logProvider, $transitionsProvider, $qProvider, tmhDynamicLocaleProvider, gettextCatalogProvider, urls, uibDatepickerConfig, uibDatepickerPopupConfig, defaultHttpRequestTransform, uiGmapGoogleMapApiProvider, localStorageServiceProvider) {
        $locationProvider.hashPrefix('!').html5Mode(true);
        $compileProvider.debugInfoEnabled(false);
        $compileProvider.aHrefSanitizationWhitelist(aHrefSanitizationWhitelist);
        $templateRequestProvider.httpOptions({ allowAnonymous: true, params: { v: window.sc3Version } });
        $qProvider.errorOnUnhandledRejections(false);
        // $logProvider.debugEnabled(false);

        // Locale
        tmhDynamicLocaleProvider.localeLocationPattern(urls.locales);
        gettextCatalogProvider.languageLocationPattern = urls.languages;

        // Http Interceptors (order matters)
        $httpProvider.interceptors.push('loadingHttpInterceptor');
        $httpProvider.interceptors.push('authorizeHttpInterceptor');
        $httpProvider.defaults.transformRequest = [defaultHttpRequestTransform];

        // Transition Hooks (order matters)
        $transitionsProvider.hooks = [];
        $transitionsProvider.hooks.push('cultureTransitionHook');
        $transitionsProvider.hooks.push('bubbaTransitionHook');
        $transitionsProvider.hooks.push('authorizeTransitionHook');
        $transitionsProvider.hooks.push('loadingTransitionHook');
        $transitionsProvider.hooks.push('startupTransitionHook');
        $transitionsProvider.hooks.push('clubAdminTransitionHook');
        $transitionsProvider.hooks.push('adminBaseTransitionHook');

        // Date Picker
        uibDatepickerConfig.showWeeks = false;
        uibDatepickerPopupConfig.datepickerPopup = 'shortDate';
        uibDatepickerPopupConfig.showButtonBar = false;

        // Google Api
        uiGmapGoogleMapApiProvider.configure({
            key: 'AIzaSyBuerUWtE1Ji8JCbaZyv1Om7pKrM0TwUHE',
            v: '3',
            libraries: 'weather,geometry,visualization'
        });

        // Object Fit Pollyfill
        objectFitImages();

        // Local Storage - Do not fallback to cookie if localStorage is unavailable.  Our token is too large for cookies.
        localStorageServiceProvider.defaultToCookie = false; 
    }
})();